import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Checkbox } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Bubble, LoaderButton } from 'ctia-ui';
import { notifyMessages } from 'helpers/NotifyHelper';
import { toggleCheckbox, updateRequest } from 'actions/request';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';

class CertificationOptions extends Component {
  onSaveClick = () => {
    const {
      request,
      updateRequest,
      startPreloader,
      finishPreloader,
      showNotice
    } = this.props;
    const { id, certificationOption } = request;
    const reqData = { id, publishdetails: certificationOption ? 1 : 0 };

    startPreloader().then(
      updateRequest(reqData)
        .then(finishPreloader)
        .then(showNotice(notifyMessages.requestUpdatedSuccessfully))
    );
  };

  render() {
    const { show, request, showHint, user } = this.props;

    if (!show) return null;

    const isEditable = user.canEditRequest;

    return (
      <div>
        <Bubble type="info" show={showHint}>
          Below you may review and update the publication option selected for
          this request.
        </Bubble>
        <Row>
          <Col xs={1} />
          <Col xs={11}>
            <Checkbox
              id="certificationOption"
              onChange={this.props.toggleCheckbox}
              value={request.certificationOption}
              checked={request.certificationOption}
              disabled={!isEditable}
            >
              Publish this device on the{' '}
              <a
                href="https://www.cbrsalliance.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                cbrsalliance.org
              </a>{' '}
              certified devices list once certified
            </Checkbox>
            <br />
            <LoaderButton
              bsStyle="default"
              text="Save changes"
              isLoading={request.isLoading}
              onClick={this.onSaveClick}
              show={isEditable}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

CertificationOptions.propTypes = {
  show: PropTypes.bool,
  showHint: PropTypes.bool
};

CertificationOptions.defaultProps = {
  show: true
};

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  {
    updateRequest,
    toggleCheckbox,
    startPreloader,
    finishPreloader,
    showNotice
  }
)(CertificationOptions);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/CertificationOptions.js